import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';

import {
    activationReducer,
    addAidReducer,
    addBlogCommentReducer,
    addCampaignCommentReducer,
    addCartReducer,
    addDepositReducer,
    addProductCommentReducer,
    addRequestCardReducer,
    applyCouponReducer,
    blogCommentsReducer,
    blogPostsReducer,
    blogViewReducer,
    campaignCommentsReducer,
    campaignDonationsReducer,
    campaignViewReducer,
    campaignDownloadDocumentReducer,
    campaignDownloadDocumentOldReducer,
    campaignDeleteTreeDocsReducer,
    categoryCampaignsReducer,
    changeCartReducer,
    changePasswordReducer,
    checkAidReducer,
    contactReducer,
    donationReducer,
    fundGetReducer,
    getCartReducer,
    homeReducer,
    loginReducer,
    messageListReducer,
    messageViewReducer,
    orderDetailReducer,
    orderListReducer,
    pageReducer,
    passwordRecoveryReducer,
    paymentsReducer,
    evetViewReducer as eventViewReducer,
    evetRegViewReducer as eventRegViewReducer,
    productListReducer,
    productViewReducer,
    productCommentsReducer,
    registerReducer,
    removeCartReducer,
    sendActivationReducer,
    submitCartReducer,
    addReminderReducer,
    submitMessageReducer,
    submitPaymentReducer,
    uploadAttachReducer,
    uploadAvatarReducer,
    uploadNationalCardReducer,
    userDataReducer,
    campaignTreeDocumentsReducer,
    campaignDonateSuccessReducer,
    donationDoReducer,
    eventRegisterReducer,
} from './reducers';

export const store = configureStore({
    reducer: {
        home: homeReducer,
        pageGet: pageReducer,
        categoryCampaignsGet: categoryCampaignsReducer,
        submitPaymentPost: submitPaymentReducer,
        productList: productListReducer,
        campaignView: campaignViewReducer,
        campaignTreeDocuments: campaignTreeDocumentsReducer,
        campaignDownloadDocument: campaignDownloadDocumentReducer,
        campaignDownloadDocumentOld: campaignDownloadDocumentOldReducer,
        campaignDeleteTreeDocs: campaignDeleteTreeDocsReducer,
        campaignCommentsGet: campaignCommentsReducer,
        campaignDonateSuccessGet: campaignDonateSuccessReducer,
        campaignDonationsGet: campaignDonationsReducer,
        blogView: blogViewReducer,
        blogPostsPost: blogPostsReducer,
        blogCommentPost: addBlogCommentReducer,
        blogCommentsGet: blogCommentsReducer,
        eventView: eventViewReducer,
        eventRegisterView: eventRegViewReducer,
        eventRegister: eventRegisterReducer,
        productView: productViewReducer,
        productCommentsGet: productCommentsReducer,
        userData: userDataReducer,
        cartGet: getCartReducer,
        addCartPost: addCartReducer,
        removeCartPost: removeCartReducer,
        changeCartPost: changeCartReducer,
        applyCouponPost: applyCouponReducer,
        submitCartReducer: submitCartReducer,
        addReminderReducer: addReminderReducer,
        donationDoReducer: donationDoReducer,
        orderListReducer: orderListReducer,
        orderDetailReducer: orderDetailReducer,
        fundGetReducer: fundGetReducer,
        messageListReducer: messageListReducer,
        messageViewReducer: messageViewReducer,
        submitMessageReducer: submitMessageReducer,
        paymentsReducer: paymentsReducer,
        checkAid: checkAidReducer,
        donationPost: donationReducer,
        contactPost: contactReducer,
        campaignCommentPost: addCampaignCommentReducer,
        productCommentPost: addProductCommentReducer,
        depositPost: addDepositReducer,
        aidPost: addAidReducer,
        uploadAvatar: uploadAvatarReducer,
        uploadNationalCard: uploadNationalCardReducer,
        uploadAttach: uploadAttachReducer,
        requestCardPost: addRequestCardReducer,
        login: loginReducer,
        register: registerReducer,
        activation: activationReducer,
        sendActivation: sendActivationReducer,
        passwordRecovery: passwordRecoveryReducer,
        changePasswordPost: changePasswordReducer
    }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;